import React, { useState } from "react";
import { ECOSYSTEM_PRODUCTS, EcosystemProduct } from "../data/ecosystemData";
import ProductCard from "./ProductCard";

type FilterCategory = "All" | "AI & Agents" | "Exchange & DEX" | "Gaming & Treasury" | "Education & Utilities";

export const ProductSuiteSection: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState<FilterCategory>("All");

  const filterOptions: { label: string; value: FilterCategory }[] = [
    { label: "All Products", value: "All" },
    { label: "AI & Agents", value: "AI & Agents" },
    { label: "Exchange & DEX", value: "Exchange & DEX" },
    { label: "Gaming & Treasury", value: "Gaming & Treasury" },
  ];

  const filteredProducts = ECOSYSTEM_PRODUCTS.filter((product: EcosystemProduct) => {
    if (activeFilter === "All") return true;
    return product.categoryTag === activeFilter;
  });

  return (
    <section className="homepage1-suite-section" id="suite">
      <div className="homepage1-suite-header">
        <div>
          <h2 className="homepage1-section-heading">
            The indexx.ai Product Suite
          </h2>
          <p className="homepage1-section-subhead">
            Interconnected sub-products engineered on unified liquidity,
            shared smart vaults, and autonomous AI.
          </p>
        </div>

        {/* Filter Tags */}
        {/* <div className="homepage1-filter-tags">
          {filterOptions.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`homepage1-filter-btn ${activeFilter === opt.value ? "active" : ""
                }`}
              onClick={() => setActiveFilter(opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div> */}
      </div>

      {/* Product Grid */}
      <div className="homepage1-product-grid">
        {filteredProducts.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
};

export default ProductSuiteSection;
